import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class AddArbetsorderRestriktionCommand extends BasicCommand<AddArbetsorderRestriktionCommand> {
    get primaryKey(): IPrimaryKey<AddArbetsorderRestriktionCommand> {
        return {
            arbetsorderId: this.arbetsorderId,
            typ: this.typ
        };
    }
    arbetsorderId: number;
    typ: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddArbetsorderRestriktionCommand";
    constructor(init: (instance: AddArbetsorderRestriktionCommand) => void) {
        super(AddArbetsorderRestriktionCommand.$type, AddArbetsorderRestriktionCommand.$groupKey, CommandType.Insert);
        init(this);
    }
}
